// http协议method
export const HttpMethod = {
    GET: 'get',
    POST: 'post'
};

// http协议头Content-Type
export const ContentType = {
    FILE: 'file', // 自定义的文件类型
    JSON: 'application/json',
    FORM_URLENCODED: 'application/x-www-form-urlencoded'
};

export const Event = {
    SHOW_LOADING: 'SHOW_LOADING',
    HIDE_LOADING: 'HIDE_LOADING',
    PIC_LOA_CHANGE: 'PIC_LOA_CHANGE'
};

export const API = {
    V1: '/api/v1.0'
};

// 报告生成状态 0：失败 1：成功
export const ReportStatus = {
    FAIL: 0,
    SUCCESS: 1
};

// 报告类型 1：风险 2：造假
export const RiskFraudType = {
    FRAUD: '2',
    RISK: '1'
};

// 用户账号状态
export const AccountStatus = {
    ENABLE: 1,
    DISABLE: 0
};

// 用户账号状态
export const AccountType = {
    NORMAL: 2,
    ADMIN: 1
};

// 画像页面code
export const PicturePageCode = {
    OVERVIEW: 1,
    INFO: 2,
    PUNISH: 3,
    FRAUD: 4,
    RISK: 5
};

/**
 * Desc: 日期类型
 * 年度
 * 三季度
 * 二季度
 * 一季度
 */
export const ReportDateType = {
    YEAR: '4',
    THIRD_QUARTER: '3',
    SECOND_QUARTER: '2',
    FIRST_QUARTER: '1'
};

export const MonthDateType = {
    '12': ReportDateType.YEAR,
    '9': ReportDateType.THIRD_QUARTER,
    '6': ReportDateType.SECOND_QUARTER,
    '3': ReportDateType.FIRST_QUARTER
};

/**
 * Desc: 报告类型
 * 合并期末_调整
 * 合并期末
 * 母公司期末_调整
 * 母公司期末
 */
export const ReportType = {
    FINAL_ADJUST: '3',
    FINAL: '1',
    PARENT_FIRM_ADJUST: '4',
    PARENT_FIRM: '2'
};

/**
 * Desc: 隐患类型
 * 财务风险隐患
 * 舞弊动机
 * 舞弊表象
 */
export const DangerType = {
    RISK: 1,
    MOTIVE: 2,
    APPEARANCE: 3
};

/**
 * @desc Demo
 * 类型或状态封装示例代码, 正式开发时请删除 Demo代码段.
 * 后端返回类型或状态字段时一般为, 数字或字符串, 如: 0, 1 或 'BUSY', 'FREE'
 * 前端应封装为对象使用(如: UserLevel.NORMAL), 这样代码清晰, 便于维护.
 */
export const UserLevel = {
    NORMAL: 0,
    VIP: 1
};

export const UserStatus = {
    ENABLE: 'enable',
    DISABLE: 'disable'
};
/**
 * Demo end
 */



// WEBPACK FOOTER //
// ./src/constants/enum.js